<template>
	<div class="tab-housekeeping">
		<v-tabs dark :scrollable="false" grow>
			<v-tabs-bar class="transparent">
				<v-tabs-item
					v-for="tab in tabs"
					:key="tab.id"
					:to="tab.link"
					exact
					>
					{{ tab.title }}
				</v-tabs-item>
				<v-tabs-slider class="default-dark"></v-tabs-slider>
			</v-tabs-bar>
		</v-tabs>
	</div>
</template>

<script>
export default {
	name: 'tabs-component',
	props: {
		tabs: {
			type: Array,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
	.tab-housekeeping {
		position: absolute;
		right: 0;
		top: 47px;
		width: 30%;

		.tabs__container {
			right: 0;
			width: auto;
		}
	}

	.default-dark {
		background: map-get($colors, default-dark);
	}
</style>




// WEBPACK FOOTER //
// TabsComponent.vue?23a053f8